import { WriteHook, useMutationManager } from 'state-manager'

import { postApplicationClientDocument } from './services'
import { ApplicationDocumentPayload } from './types'

export const usePostApplicationClientDocument: WriteHook<ApplicationDocumentPayload, unknown> = (opts) =>
  useMutationManager<ApplicationDocumentPayload, unknown>(postApplicationClientDocument, opts)
